import React from "react";
import { Box, Typography } from "@mui/material";
import { withAuth } from "../../hoc";
import UserSubscriptionsList from "./UserSubscriptionsList";

const SubscriptionsOrders = (): JSX.Element => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        p: { xs: 2, md: 3 },
        height: "100%",
        display: "flex",
        overflow: "hidden",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
          flexShrink: 0,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Typography variant="h5" fontWeight={600}>
            Subscriptions
          </Typography>
        </Box>
      </Box>
      <UserSubscriptionsList />
    </Box>
  );
};

export default withAuth(SubscriptionsOrders);
